var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCollapse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "plus-a",
    d: "M8.08921297,3.14059605 C7.7617771,2.84202354 7.23295395,2.84202354 6.90552017,3.14059605 L4.97887124,4.9040462 L3.05222231,3.14059605 C2.70006575,2.86396003 2.17010676,2.90156964 1.86852953,3.22460022 C1.59937877,3.51289544 1.59937919,3.93809292 1.8685299,4.22639007 L4.97887163,7.08333333 L8.08921337,4.22639007 C8.41470665,3.92603561 8.41470665,3.44095013 8.08921337,3.14059761 L8.08921297,3.14059605 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#2B2F88",
    xlinkHref: "#plus-a"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCollapse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Collapse.3c528780.svg";
export { ForwardRef as ReactComponent };